import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CrossComponentService {

  homePopup = signal<boolean>(false);
  homePopupData = signal<any>({});

  illustratedModal = signal<boolean>(false);
  illustratedModalData = signal<any>({});

  callModal = signal<boolean>(false);
  callModalData = signal<any>({});

  openHomePopup() {
    this.homePopup.set(true);
  }

  closeHomePopup() {
    this.homePopup.set(false);
  }

  dataHomePopup(data: any = {}) {
    this.homePopupData.set(data);
  }

  openIllustratedModal() {
    this.illustratedModal.set(true);
  }

  closeIllustratedModal() {
    this.illustratedModal.set(false);
  }

  dataIllustratedModal(data: any = {}) {
    this.illustratedModalData.set(data);
  }

  openCallModal() {
    this.callModal.set(true);
  }

  closeCallModal() {
    this.callModal.set(false);
  }

  dataCallModal(data: any = {}) {
    this.callModalData.set(data);
  }
}
